// Module
var code = "<react-component name=\"EmailVerificationsReport\"></react-component>\n";
// Exports
module.exports = code;